var map = {
	"./actual-size-24x24.svg": "./src/images-v1/actual-size-24x24.svg",
	"./add-16x16.svg": "./src/images-v1/add-16x16.svg",
	"./add-24x24.svg": "./src/images-v1/add-24x24.svg",
	"./apply-24x24.svg": "./src/images-v1/apply-24x24.svg",
	"./arrowdown-24x24.svg": "./src/images-v1/arrowdown-24x24.svg",
	"./arrowleft-16x16.svg": "./src/images-v1/arrowleft-16x16.svg",
	"./arrowleft-24x24.svg": "./src/images-v1/arrowleft-24x24.svg",
	"./arrowright-16x16.svg": "./src/images-v1/arrowright-16x16.svg",
	"./arrowright-24x24.svg": "./src/images-v1/arrowright-24x24.svg",
	"./arrowup-24x24.svg": "./src/images-v1/arrowup-24x24.svg",
	"./camera-24x24.svg": "./src/images-v1/camera-24x24.svg",
	"./camera-32x32.svg": "./src/images-v1/camera-32x32.svg",
	"./cancel-24x24.svg": "./src/images-v1/cancel-24x24.svg",
	"./check-16x16.svg": "./src/images-v1/check-16x16.svg",
	"./check-24x24.svg": "./src/images-v1/check-24x24.svg",
	"./chevrondown-16x16.svg": "./src/images-v1/chevrondown-16x16.svg",
	"./chevrondown-24x24.svg": "./src/images-v1/chevrondown-24x24.svg",
	"./chevronleft-16x16.svg": "./src/images-v1/chevronleft-16x16.svg",
	"./chevronup-24x24.svg": "./src/images-v1/chevronup-24x24.svg",
	"./clear-16x16.svg": "./src/images-v1/clear-16x16.svg",
	"./clear-24x24.svg": "./src/images-v1/clear-24x24.svg",
	"./close-16x16.svg": "./src/images-v1/close-16x16.svg",
	"./close-24x24.svg": "./src/images-v1/close-24x24.svg",
	"./codeeditor-24x24.svg": "./src/images-v1/codeeditor-24x24.svg",
	"./collapse-16x16.svg": "./src/images-v1/collapse-16x16.svg",
	"./collapse-24x24.svg": "./src/images-v1/collapse-24x24.svg",
	"./collapse-pg-24x24.svg": "./src/images-v1/collapse-pg-24x24.svg",
	"./collapseall-24x24.svg": "./src/images-v1/collapseall-24x24.svg",
	"./collapsedetails-16x16.svg": "./src/images-v1/collapsedetails-16x16.svg",
	"./collapsefocused-16x16.svg": "./src/images-v1/collapsefocused-16x16.svg",
	"./collapsepage-16x16.svg": "./src/images-v1/collapsepage-16x16.svg",
	"./collapsepanel-16x16.svg": "./src/images-v1/collapsepanel-16x16.svg",
	"./copy-16x16.svg": "./src/images-v1/copy-16x16.svg",
	"./copy-24x24.svg": "./src/images-v1/copy-24x24.svg",
	"./cross-24x24.svg": "./src/images-v1/cross-24x24.svg",
	"./delete-16x16.svg": "./src/images-v1/delete-16x16.svg",
	"./delete-24x24.svg": "./src/images-v1/delete-24x24.svg",
	"./desktop-24x24.svg": "./src/images-v1/desktop-24x24.svg",
	"./download-24x24.svg": "./src/images-v1/download-24x24.svg",
	"./drag-24x24.svg": "./src/images-v1/drag-24x24.svg",
	"./draghorizontal-24x16.svg": "./src/images-v1/draghorizontal-24x16.svg",
	"./draghorizontalsmall-24x16.svg": "./src/images-v1/draghorizontalsmall-24x16.svg",
	"./dropper-16x16.svg": "./src/images-v1/dropper-16x16.svg",
	"./edit-16x16.svg": "./src/images-v1/edit-16x16.svg",
	"./edit-24x24.svg": "./src/images-v1/edit-24x24.svg",
	"./editsmall-16x16.svg": "./src/images-v1/editsmall-16x16.svg",
	"./embedsurvey-24x24.svg": "./src/images-v1/embedsurvey-24x24.svg",
	"./error-16x16.svg": "./src/images-v1/error-16x16.svg",
	"./error-24x24.svg": "./src/images-v1/error-24x24.svg",
	"./expand-16x16.svg": "./src/images-v1/expand-16x16.svg",
	"./expand-24x24.svg": "./src/images-v1/expand-24x24.svg",
	"./expand-pg-24x24.svg": "./src/images-v1/expand-pg-24x24.svg",
	"./expandall-24x24.svg": "./src/images-v1/expandall-24x24.svg",
	"./expanddetails-16x16.svg": "./src/images-v1/expanddetails-16x16.svg",
	"./expandfocused-16x16.svg": "./src/images-v1/expandfocused-16x16.svg",
	"./expandpage-16x16.svg": "./src/images-v1/expandpage-16x16.svg",
	"./expandpanel-16x16.svg": "./src/images-v1/expandpanel-16x16.svg",
	"./file-72x72.svg": "./src/images-v1/file-72x72.svg",
	"./finishedit-24x24.svg": "./src/images-v1/finishedit-24x24.svg",
	"./fix-24x24.svg": "./src/images-v1/fix-24x24.svg",
	"./flip-24x24.svg": "./src/images-v1/flip-24x24.svg",
	"./folder-24x24.svg": "./src/images-v1/folder-24x24.svg",
	"./fullsize-16x16.svg": "./src/images-v1/fullsize-16x16.svg",
	"./gear-24x24.svg": "./src/images-v1/gear-24x24.svg",
	"./help-24x24.svg": "./src/images-v1/help-24x24.svg",
	"./hidehint-16x16.svg": "./src/images-v1/hidehint-16x16.svg",
	"./hidehint-24x24.svg": "./src/images-v1/hidehint-24x24.svg",
	"./hint-16x16.svg": "./src/images-v1/hint-16x16.svg",
	"./hint-24x24.svg": "./src/images-v1/hint-24x24.svg",
	"./image-48x48.svg": "./src/images-v1/image-48x48.svg",
	"./import-24x24.svg": "./src/images-v1/import-24x24.svg",
	"./invisible-24x24.svg": "./src/images-v1/invisible-24x24.svg",
	"./language-24x24.svg": "./src/images-v1/language-24x24.svg",
	"./loading-48x48.svg": "./src/images-v1/loading-48x48.svg",
	"./logic-24x24.svg": "./src/images-v1/logic-24x24.svg",
	"./logo-angular-24x24.svg": "./src/images-v1/logo-angular-24x24.svg",
	"./logo-jquery-24x24.svg": "./src/images-v1/logo-jquery-24x24.svg",
	"./logo-knockout-24x24.svg": "./src/images-v1/logo-knockout-24x24.svg",
	"./logo-react-24x24.svg": "./src/images-v1/logo-react-24x24.svg",
	"./logo-surveycreator-48x48.svg": "./src/images-v1/logo-surveycreator-48x48.svg",
	"./logo-vue-24x24.svg": "./src/images-v1/logo-vue-24x24.svg",
	"./maximize-16x16.svg": "./src/images-v1/maximize-16x16.svg",
	"./minimize-16x16.svg": "./src/images-v1/minimize-16x16.svg",
	"./minus-32x32.svg": "./src/images-v1/minus-32x32.svg",
	"./minusbox-16x16.svg": "./src/images-v1/minusbox-16x16.svg",
	"./more-16x16.svg": "./src/images-v1/more-16x16.svg",
	"./more-24x24.svg": "./src/images-v1/more-24x24.svg",
	"./navmenu-24x24.svg": "./src/images-v1/navmenu-24x24.svg",
	"./noimage-48x48.svg": "./src/images-v1/noimage-48x48.svg",
	"./pg-appearance-24x24.svg": "./src/images-v1/pg-appearance-24x24.svg",
	"./pg-background-24x24.svg": "./src/images-v1/pg-background-24x24.svg",
	"./pg-columns-24x24.svg": "./src/images-v1/pg-columns-24x24.svg",
	"./pg-conditions-24x24.svg": "./src/images-v1/pg-conditions-24x24.svg",
	"./pg-data-24x24.svg": "./src/images-v1/pg-data-24x24.svg",
	"./pg-design-24x24.svg": "./src/images-v1/pg-design-24x24.svg",
	"./pg-general-24x24.svg": "./src/images-v1/pg-general-24x24.svg",
	"./pg-header-24x24.svg": "./src/images-v1/pg-header-24x24.svg",
	"./pg-language-24x24.svg": "./src/images-v1/pg-language-24x24.svg",
	"./pg-layout-24x24.svg": "./src/images-v1/pg-layout-24x24.svg",
	"./pg-logo-24x24.svg": "./src/images-v1/pg-logo-24x24.svg",
	"./pg-navigation-24x24.svg": "./src/images-v1/pg-navigation-24x24.svg",
	"./pg-numbering-24x24.svg": "./src/images-v1/pg-numbering-24x24.svg",
	"./pg-pages-24x24.svg": "./src/images-v1/pg-pages-24x24.svg",
	"./pg-questiondesign-24x24.svg": "./src/images-v1/pg-questiondesign-24x24.svg",
	"./pg-quiz-24x24.svg": "./src/images-v1/pg-quiz-24x24.svg",
	"./pg-rows-24x24.svg": "./src/images-v1/pg-rows-24x24.svg",
	"./pg-specific-24x24.svg": "./src/images-v1/pg-specific-24x24.svg",
	"./pg-thankyyoupage-24x24.svg": "./src/images-v1/pg-thankyyoupage-24x24.svg",
	"./pg-themes-24x24.svg": "./src/images-v1/pg-themes-24x24.svg",
	"./pg-totals-24x24.svg": "./src/images-v1/pg-totals-24x24.svg",
	"./pg-undefined-24x24.svg": "./src/images-v1/pg-undefined-24x24.svg",
	"./pg-validation-24x24.svg": "./src/images-v1/pg-validation-24x24.svg",
	"./pg-webservice-24x24.svg": "./src/images-v1/pg-webservice-24x24.svg",
	"./phone-24x24.svg": "./src/images-v1/phone-24x24.svg",
	"./plus-32x32.svg": "./src/images-v1/plus-32x32.svg",
	"./plusbox-16x16.svg": "./src/images-v1/plusbox-16x16.svg",
	"./preview-24x24.svg": "./src/images-v1/preview-24x24.svg",
	"./publish-24x24.svg": "./src/images-v1/publish-24x24.svg",
	"./questionlock-24x24.svg": "./src/images-v1/questionlock-24x24.svg",
	"./ranking-arrows.svg": "./src/images-v1/ranking-arrows.svg",
	"./rankingundefined-16x16.svg": "./src/images-v1/rankingundefined-16x16.svg",
	"./redo-24x24.svg": "./src/images-v1/redo-24x24.svg",
	"./refresh-16x16.svg": "./src/images-v1/refresh-16x16.svg",
	"./remove-16x16.svg": "./src/images-v1/remove-16x16.svg",
	"./reorder-24x24.svg": "./src/images-v1/reorder-24x24.svg",
	"./required-16x16.svg": "./src/images-v1/required-16x16.svg",
	"./restore-24x24.svg": "./src/images-v1/restore-24x24.svg",
	"./restoredown-16x16.svg": "./src/images-v1/restoredown-16x16.svg",
	"./rotate-24x24.svg": "./src/images-v1/rotate-24x24.svg",
	"./save-24x24.svg": "./src/images-v1/save-24x24.svg",
	"./saveas-24x24.svg": "./src/images-v1/saveas-24x24.svg",
	"./search-24x24.svg": "./src/images-v1/search-24x24.svg",
	"./selectpage-24x24.svg": "./src/images-v1/selectpage-24x24.svg",
	"./settings-16x16.svg": "./src/images-v1/settings-16x16.svg",
	"./settings-24x24.svg": "./src/images-v1/settings-24x24.svg",
	"./smile-24x24.svg": "./src/images-v1/smile-24x24.svg",
	"./smiley-rate0-24x24.svg": "./src/images-v1/smiley-rate0-24x24.svg",
	"./smiley-rate1-24x24.svg": "./src/images-v1/smiley-rate1-24x24.svg",
	"./smiley-rate10-24x24.svg": "./src/images-v1/smiley-rate10-24x24.svg",
	"./smiley-rate2-24x24.svg": "./src/images-v1/smiley-rate2-24x24.svg",
	"./smiley-rate3-24x24.svg": "./src/images-v1/smiley-rate3-24x24.svg",
	"./smiley-rate4-24x24.svg": "./src/images-v1/smiley-rate4-24x24.svg",
	"./smiley-rate5-24x24.svg": "./src/images-v1/smiley-rate5-24x24.svg",
	"./smiley-rate6-24x24.svg": "./src/images-v1/smiley-rate6-24x24.svg",
	"./smiley-rate7-24x24.svg": "./src/images-v1/smiley-rate7-24x24.svg",
	"./smiley-rate8-24x24.svg": "./src/images-v1/smiley-rate8-24x24.svg",
	"./smiley-rate9-24x24.svg": "./src/images-v1/smiley-rate9-24x24.svg",
	"./speechbubble-16x16.svg": "./src/images-v1/speechbubble-16x16.svg",
	"./switchoff-16x16.svg": "./src/images-v1/switchoff-16x16.svg",
	"./switchon-16x16.svg": "./src/images-v1/switchon-16x16.svg",
	"./tablet-24x24.svg": "./src/images-v1/tablet-24x24.svg",
	"./textedit-24x24.svg": "./src/images-v1/textedit-24x24.svg",
	"./theme-24x24.svg": "./src/images-v1/theme-24x24.svg",
	"./toolbox-24x24.svg": "./src/images-v1/toolbox-24x24.svg",
	"./toolbox-boolean-16x16.svg": "./src/images-v1/toolbox-boolean-16x16.svg",
	"./toolbox-boolean-24x24.svg": "./src/images-v1/toolbox-boolean-24x24.svg",
	"./toolbox-checkbox-16x16.svg": "./src/images-v1/toolbox-checkbox-16x16.svg",
	"./toolbox-checkbox-24x24.svg": "./src/images-v1/toolbox-checkbox-24x24.svg",
	"./toolbox-customquestion-16x16.svg": "./src/images-v1/toolbox-customquestion-16x16.svg",
	"./toolbox-customquestion-24x24.svg": "./src/images-v1/toolbox-customquestion-24x24.svg",
	"./toolbox-dropdown-16x16.svg": "./src/images-v1/toolbox-dropdown-16x16.svg",
	"./toolbox-dropdown-24x24.svg": "./src/images-v1/toolbox-dropdown-24x24.svg",
	"./toolbox-dynamicmatrix-16x16.svg": "./src/images-v1/toolbox-dynamicmatrix-16x16.svg",
	"./toolbox-dynamicmatrix-24x24.svg": "./src/images-v1/toolbox-dynamicmatrix-24x24.svg",
	"./toolbox-dynamicpanel-16x16.svg": "./src/images-v1/toolbox-dynamicpanel-16x16.svg",
	"./toolbox-dynamicpanel-24x24.svg": "./src/images-v1/toolbox-dynamicpanel-24x24.svg",
	"./toolbox-expression-16x16.svg": "./src/images-v1/toolbox-expression-16x16.svg",
	"./toolbox-expression-24x24.svg": "./src/images-v1/toolbox-expression-24x24.svg",
	"./toolbox-file-16x16.svg": "./src/images-v1/toolbox-file-16x16.svg",
	"./toolbox-file-24x24.svg": "./src/images-v1/toolbox-file-24x24.svg",
	"./toolbox-html-16x16.svg": "./src/images-v1/toolbox-html-16x16.svg",
	"./toolbox-html-24x24.svg": "./src/images-v1/toolbox-html-24x24.svg",
	"./toolbox-image-16x16.svg": "./src/images-v1/toolbox-image-16x16.svg",
	"./toolbox-image-24x24.svg": "./src/images-v1/toolbox-image-24x24.svg",
	"./toolbox-imagepicker-16x16.svg": "./src/images-v1/toolbox-imagepicker-16x16.svg",
	"./toolbox-imagepicker-24x24.svg": "./src/images-v1/toolbox-imagepicker-24x24.svg",
	"./toolbox-longtext-16x16.svg": "./src/images-v1/toolbox-longtext-16x16.svg",
	"./toolbox-longtext-24x24.svg": "./src/images-v1/toolbox-longtext-24x24.svg",
	"./toolbox-matrix-16x16.svg": "./src/images-v1/toolbox-matrix-16x16.svg",
	"./toolbox-matrix-24x24.svg": "./src/images-v1/toolbox-matrix-24x24.svg",
	"./toolbox-multimatrix-16x16.svg": "./src/images-v1/toolbox-multimatrix-16x16.svg",
	"./toolbox-multimatrix-24x24.svg": "./src/images-v1/toolbox-multimatrix-24x24.svg",
	"./toolbox-multipletext-16x16.svg": "./src/images-v1/toolbox-multipletext-16x16.svg",
	"./toolbox-multipletext-24x24.svg": "./src/images-v1/toolbox-multipletext-24x24.svg",
	"./toolbox-panel-16x16.svg": "./src/images-v1/toolbox-panel-16x16.svg",
	"./toolbox-panel-24x24.svg": "./src/images-v1/toolbox-panel-24x24.svg",
	"./toolbox-radiogroup-16x16.svg": "./src/images-v1/toolbox-radiogroup-16x16.svg",
	"./toolbox-radiogroup-24x24.svg": "./src/images-v1/toolbox-radiogroup-24x24.svg",
	"./toolbox-ranking-16x16.svg": "./src/images-v1/toolbox-ranking-16x16.svg",
	"./toolbox-ranking-24x24.svg": "./src/images-v1/toolbox-ranking-24x24.svg",
	"./toolbox-rating-16x16.svg": "./src/images-v1/toolbox-rating-16x16.svg",
	"./toolbox-rating-24x24.svg": "./src/images-v1/toolbox-rating-24x24.svg",
	"./toolbox-signature-16x16.svg": "./src/images-v1/toolbox-signature-16x16.svg",
	"./toolbox-signature-24x24.svg": "./src/images-v1/toolbox-signature-24x24.svg",
	"./toolbox-singleline-16x16.svg": "./src/images-v1/toolbox-singleline-16x16.svg",
	"./toolbox-singleline-24x24.svg": "./src/images-v1/toolbox-singleline-24x24.svg",
	"./toolbox-tagbox-16x16.svg": "./src/images-v1/toolbox-tagbox-16x16.svg",
	"./toolbox-tagbox-24x24.svg": "./src/images-v1/toolbox-tagbox-24x24.svg",
	"./undo-24x24.svg": "./src/images-v1/undo-24x24.svg",
	"./visible-24x24.svg": "./src/images-v1/visible-24x24.svg",
	"./wand-24x24.svg": "./src/images-v1/wand-24x24.svg",
	"./warning-24x24.svg": "./src/images-v1/warning-24x24.svg",
	"./wrench-24x24.svg": "./src/images-v1/wrench-24x24.svg",
	"./zoomin-24x24.svg": "./src/images-v1/zoomin-24x24.svg",
	"./zoomout-24x24.svg": "./src/images-v1/zoomout-24x24.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images-v1 sync recursive \\.svg$";